import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { StrategyService } from '../../services/strategy.service';
import { Pillar, Strategy } from '../../interfaces/models/strategy.model';
import { FormGroup, FormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CommonModule } from '@angular/common';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastrService } from 'ngx-toastr';
import { GoalService } from '../../services/goal.service';
import { Goal } from '../../interfaces/models/goal.model';
import { ConfirmPopup, ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmationService } from 'primeng/api';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { authUser } from '../../interfaces/auth/auth.model';
import { SocketService } from '../../services/socket.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { CustomAblePipe } from '../../pipes/able.pipe';
import { GoalsComponent } from '../../shared/components/goals/goals.component';
import { TableModule } from 'primeng/table';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';
import { filterActive } from '../../utils/filter-active';

@Component({
  selector: 'app-strategic-goal',
  standalone: true,
  imports: [
    NavTitlePipe,TableModule, GoalsComponent, CustomAblePipe, ButtonModule, ConfirmPopupModule, TranslateModule, ButtonModule, IconFieldModule, InputTextModule, InputTextareaModule, InputIconModule, CommonModule, RouterModule, DropdownModule, FormsModule, RadioButtonModule],
  templateUrl: './strategic-goal.component.html',
  providers: [ConfirmationService],
  styleUrl: './strategic-goal.component.scss'
})
export class StrategicGoalComponent implements OnInit, OnDestroy {
  @ViewChild(ConfirmPopup) confirmPopup!: ConfirmPopup;
  @ViewChild('goalForm') goalForm!: FormGroup;
  displayType = 'cards'; // Default to cards view
  selectedStrategyId = 0;
  _selectedpillarId = 0;
  set selectedpillarId(id: number) {
    this.setSelectedpillarIdChange(id);
    this._selectedpillarId = id
  }


  get selectedpillarId() {
    return this._selectedpillarId;
  }

  set searchTerm(term: string) {
    this.searchGoalsByNameOrChar(term);
    this._searchTerm = term;
  }


  get searchTerm() {
    return this._searchTerm;
  }



  strategyOptions = [] as { name: string, strategyId: number }[];
  pillars: Pillar[] | undefined;
  pillarOptions: { name: string, id: number }[] = [];
  goals!: any[];
  selectedUpdateGoalId = 0;
  _searchTerm = ""
  selectedGoal = {} as Goal;
  isVisibleGoalModal = false;
  isViewDetailsModal = false;
  selectedViewGoal: any = null;
  selectedStrategy!: Strategy;
  user!: authUser;
  dir!: 'rtl' | 'ltr'
  isGoalFormSubmitted = false;
  constructor(
    private strategyService: StrategyService,
    private route: ActivatedRoute,
    private goalService: GoalService,
    private toastr: ToastrService,
    private confirmationService: ConfirmationService,
    private authService: AuthService,
    private translate: TranslateService,
    private directionService: DirectionService
  ) {
  }
  private unsubscribe$ = new Subject<void>();

  private allLabel(): string {
    return this.translate.instant('all') || (this.dir === 'rtl' ? 'الكل' : 'All');
  }

  private buildPillarOptions(pillars: Pillar[] | undefined | null): void {
    const activePillars = filterActive(pillars as any[]);
    this.pillars = activePillars as Pillar[];
    this.pillarOptions = [
      { name: this.allLabel(), id: 0 },
      ...activePillars.map(p => ({ name: p.name, id: p.id }))
    ];
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
  ngOnInit(): void {

    this.route.data.pipe(takeUntil(this.unsubscribe$))
      .subscribe(({ goalPageData }) => {
        this.selectedStrategy = goalPageData.strategy
        this.selectedStrategyId = this.selectedStrategy.id;
        this.goals = filterActive(goalPageData.goals);
        this.strategyService.setStrategyIdfn(this.selectedStrategyId)
        this.strategyOptions = filterActive(goalPageData.strategies).map((x: any) => ({ name: x.name, strategyId: x.id }))
      })
    this.authService.authBufferSub$.pipe(takeUntil(this.unsubscribe$)).subscribe((user) => {
      this.user = user as authUser;
    })
    this.directionService.direction$.pipe(takeUntil(this.unsubscribe$)).subscribe((dir) => {
      this.dir = dir;
      if (this.pillars?.length) {
        this.buildPillarOptions(this.pillars);
      }
    })
    //pillars based on strategy
    this.strategyService.selectedStrategyPillars$.pipe(takeUntil(this.unsubscribe$)).subscribe(pillars => {
      this.buildPillarOptions(pillars);
    })
    //goals-based on piller
    this.strategyService.selectedPillarsGoals$.pipe(takeUntil(this.unsubscribe$)).subscribe(goals => {
      this.goals = filterActive(goals);
    })
    //filter goals by name and ...
    this.strategyService.filterdPillarsGoals$.pipe(takeUntil(this.unsubscribe$)).subscribe(goals => {
      this.goals = filterActive(goals);
    })
    //strategy options dropdownList
  }





  strategyOptionsChange() {
    this.strategyService.getStrategyById(this.selectedStrategyId.toString()).pipe(takeUntil(this.unsubscribe$)).subscribe((strategy: any) => {
      this.selectedStrategy = strategy['data']['strategy'] as Strategy;
      this.strategyService.setStrategyIdfn(this.selectedStrategyId)
      this.strategyService.setSelectedPillarIdfn(0)
    })
  }


  setSelectedpillarIdChange(id: number) {
    this.strategyService.setSelectedPillarIdfn(id)
  }
  searchGoalsByNameOrChar(term: string) {
    this.strategyService.setGoalSearchtermfn(term);
  }

  showGoalModal() {
    this.isVisibleGoalModal = !this.isVisibleGoalModal;
  }

  submitGoal() {
    this.isGoalFormSubmitted = false;
    if (this.selectedUpdateGoalId == 0 && this.goalForm.valid) {
      this.goalService.createGoal(this.goalForm.value, +this.selectedStrategyId).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
        this.toastr.success(this.dir == 'rtl' ? 'تم الاضافة' : 'The goal has been added successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        const pillar = this.pillars?.find(x => x.id == this.goalForm.value['pillar_id'])
        this.goals?.push({ ...this.goalForm.value, pillar, id: response["data"]["entity"]["id"] } as Goal)
        console.log('goal', { ...this.goalForm.value, pillar, id: response["data"]["entity"]["id"] });
        this.goalForm.reset({});
        this.isGoalFormSubmitted = false;
        this.isVisibleGoalModal = false;
      })
      // update
    } else if (this.selectedUpdateGoalId > 0) {
      const { pillar_id, name, icon, description, weight, code } = this.selectedGoal;
      const finalSelectedGoal = { pillar_id, name, icon, description, code, weight }
      this.goalService.updateGoals(finalSelectedGoal, +this.selectedStrategyId, this.selectedUpdateGoalId).pipe(takeUntil(this.unsubscribe$)).subscribe((response: any) => {
        this.toastr.success(this.dir == 'rtl' ? "تم التعديل" : "Updated Successfully");
        this.isGoalFormSubmitted = false;
        this.goals = this.goals?.map(x => {
          if (x.id == this.selectedUpdateGoalId) {
            return this.selectedGoal;
          } else {
            return x;
          }
        })
        this.selectedUpdateGoalId = 0;
        this.selectedGoal = {} as Goal;
        this.isVisibleGoalModal = false;
      })
    }
  }

  closeGoalModal() {
    this.selectedUpdateGoalId = 0;
    this.selectedGoal = {} as Goal;
    this.isVisibleGoalModal = false;

  }

  confirmGoalDelete(event: Event, id: number) {
    const target = event.target as HTMLElement;
    this.confirmationService.confirm({
      target: target,
      message: this.dir == 'rtl' ? 'هل تريد تأكيد المسح؟' : 'Do you want to confirm the deletion?',
      accept: () => {
        this.goalService.deleteGoal(+this.selectedStrategyId, id).pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
          this.goals = this.goals?.filter(goal => goal.id != id);
          this.toastr.success(this.dir == 'rtl' ? 'تمت المسح ' : 'The goal has been deleted successfully.', this.dir == 'rtl' ? 'عملية ناجحة' : 'Success');
        })
      },
      reject: () => {
        this.toastr.info(this.dir == 'rtl' ? "تم الالغاء" : "The deletion has been canceled.", this.dir == 'rtl' ? 'الغاء' : 'Canceled');
      }
    });
  }

  accept() {
    this.confirmPopup.accept();
  }

  reject() {
    this.confirmPopup.reject();
  }


  showUpdateGoalModal(goalId: number) {
    this.selectedUpdateGoalId = goalId;
    const goal = this.goals?.find(x => x.id == goalId);
    this.selectedGoal = {
      ...goal,
      pillar_id: goal?.pillar_id ?? goal?.pillar?.id,
    } as Goal;
    this.isVisibleGoalModal = !this.isVisibleGoalModal;
  }
  selectPillarFn(pillarId: number) {
    this.selectedpillarId = pillarId;
  }
  
  showGoalDetails(goal: any) {
    this.selectedViewGoal = goal;
    this.isViewDetailsModal = true;
  }
  
  closeDetailsModal() {
    this.isViewDetailsModal = false;
    this.selectedViewGoal = null;
  }
  
  // Get icon for goals based on index (cycling through environmental icons)
  getGoalIcon(index: number): string {
    const icons = [
      'fa-solid fa-wind',
      'fa-solid fa-leaf',
      'fa-solid fa-water',
      'fa-solid fa-droplet',
      'fa-solid fa-seedling',
      'fa-solid fa-users-gear',
      'fa-solid fa-brain',
      'fa-solid fa-tree',
      'fa-solid fa-mountain',
      'fa-solid fa-sun'
    ];
    return icons[index % icons.length];
  }

}